import * as Yup from 'yup';
import { BaseForm } from '../../../../shared/domain/forms/BaseForm';
import {
  isDateTimeInFuture,
  isValidDateTimeInput
} from '../../../../utils/date';

export class CreateEditOccurrenceTransportForm extends BaseForm<CreateEditOccurrenceTransportForm> {
  id: string = '';
  occurrenceId: string = '';
  interruptedTransport: boolean | undefined = undefined;
  transportId: string = '';
  dateInterruption: string = '';
  releaseDate: string = '';
  transportDescription: string = '';

  validationSchema: Yup.SchemaOf<{
    interruptedTransport: boolean;
  }> = Yup.object().shape({
    interruptedTransport: Yup.boolean()
      .nullable()
      .required(this.requiredDefaultMsg('transporte interrompido')),
    transportId: Yup.string()
      .nullable()
      .required(this.requiredDefaultMsg('tipo de transporte')),
    dateInterruption: Yup.string()
      .nullable()
      .test('valid-date-time', 'Data da interrupção inválida', value => {
        if (!value) return true;
        return isValidDateTimeInput(value);
      })
      .test(
        'not-in-future',
        'A data da interrupção não pode ser no futuro',
        value => {
          if (!value) return true;
          return !isDateTimeInFuture(value);
        }
      ),
    releaseDate: Yup.string()
      .nullable()
      .test('valid-date-time', 'Data da liberação inválida', value => {
        if (!value) return true;
        return isValidDateTimeInput(value);
      })
      .test(
        'not-in-future',
        'A data da liberação não pode ser no futuro',
        value => {
          if (!value) return true;
          return !isDateTimeInFuture(value);
        }
      )
  });

  constructor(data?: Partial<CreateEditOccurrenceTransportForm>) {
    super();
    Object.assign(this, data);
  }
}
